function Hospitals(){
    return (
        <div className="text-orange-400 text-center font-extrabold text-4xl flex flex-col gap-4">
            <div>Hospital 1</div>
            <div>Hospital 2</div>
            <div>Hospital 3</div>
            <div>Hospital 4</div>


        </div>
    )

}
export default Hospitals;